import * as $ from 'jquery';
import 'easy-autocomplete';

export default (function () {
    class SearhBar {
        constructor($el) {
            this.$el = $el;
            this.options = {
                requestDelay: 500,
                url: (phrase) => {
                    return "/search/?phrase=" + phrase;
                },

                getValue: "name",

                categories: [
                    {
                        listLocation: "orders",
                        header: "-- Orders --"
                    },
                    {
                        listLocation: "trainings",
                        header: "-- Courses --"
                    },
                    {
                        listLocation: "editions",
                        header: "-- Editions --"
                    },
                    {
                        listLocation: "articles",
                        header: "-- Articles --"
                    },
                    {
                        listLocation: "participants",
                        header: "-- Participants --"
                    }
                ],

                list: {
                    maxNumberOfElements: 50,
                    match: {
                        enabled: true
                    },
                    onChooseEvent: () => {
                        window.location = this.$el.getSelectedItemData().link;
                    }
                }
            };

            this.init();
        }

        init() {
            this.$el.easyAutocomplete(this.options);
        }
    }
    $(document).ready(() => {
        var $searchBar = $('[data-search-bar]');
        if($searchBar.length > 0) {
            $searchBar.each(function(){
                new SearhBar($(this))
            });
        }
    });
}())

